<template>
  <div
    class="rounded-md shadow-lg border border-gray-200 bg-white overflow-hidden
      h1 grid grid-cols-1 grid-rows-[3em_auto_auto]"
  >
    <!-- title with image background -->
    <div
      class="relative flex flex-col"
    >
      <!-- suppress RequiredAttributes -->
      <NuxtPicture
        class="overflow-hidden"
        :src="props.background.src"
        :alt="props.background.alt || ''"
        :title="props.background.title"
      />
      <h3
        class="h1 absolute bottom-[0.5em] left-[1em] text-white"
      >
        {{ props.title }}
      </h3>
    </div>

    <!-- divider -->
    <span
      class="bg-server h-full w-full
        min-h-[10px] min-w-[10px] laptop:min-h-[15px] laptop:min-w-[15px]"
    />

    <!-- stats -->
    <table
      class="b1"
    >
      <template
        v-for="(stat, index) in props.stats"
        :key="stat.key || index"
      >
        <tr
          class="even:bg-gray-100"
        >
          <td
            class="pl-cl py-2 text-slate-900"
          >
            {{ stat.label }}
          </td>
          <td
            class="text-center pr-cr py-2 text-slate-900"
          >
            {{ stat.value !== undefined ? stat.value : (stat.default !== undefined ? stat.default : defaultValue) }}
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script setup lang="ts">
import type { Image } from '~/utils/types'

const defaultValue = '-'

interface Stat {
  key?: string
  label: string
  value?: string | number
  default?: string
  description?: string
}

const props = defineProps<{
  title: string
  background: Image
  stats: Stat[]
}>()
</script>

<style scoped lang="postcss">
:deep(img) {
  @apply w-full h-full object-cover
}
</style>
